<template>
  <Modal v-if="sortie.phase === 'aide'" size="large" class="aide-navigateur">
    <template #body>
      <h3 class="aide-navigateur__titre">Ouvre Animax avec ton navigateur</h3>
      <p class="aide-navigateur__alerte">
        Attention : si tu restes ici, ta collection peut être perdue quand tu fermes cette appli.
      </p>
      <p v-if="sortie.ios">
        Touche le bouton de partage « ⇪ » ou les « … », puis « Ouvrir dans Safari ».
      </p>
      <p v-else>
        Touche les trois points « ⋮ » en haut de l'écran, puis « Ouvrir dans le navigateur ».
      </p>
      <p class="aide-navigateur__parent">
        Parent : tu peux aussi copier le lien et le coller dans Chrome ou Safari.
      </p>
      <input
        v-if="lienVisible"
        class="aide-navigateur__lien"
        readonly
        :value="sortie.lien"
        @focus="$event.target.select()"
      />
    </template>
    <template #footer>
      <button class="button button__gold" @click="copier">
        {{ copie ? "Lien copié !" : "Copier le lien" }}
      </button>
      <button class="aide-navigateur__ici" @click="continuerIci(track)">
        Continuer ici quand même
      </button>
      <p class="aide-navigateur__risque">
        (ta collection peut être perdue à la fermeture de cette appli)
      </p>
    </template>
  </Modal>
</template>

<script setup>
// A12 : aide affichée quand la sortie du navigateur intégré n'a pas marché
// (navigateur/sortie.js). Montée une fois dans App.vue.
import { ref } from "vue";
import Modal from "@/components/Modal.vue";
import { track } from "@/firebase/analytics";
import { sortie, continuerIci } from "./sortie";

const copie = ref(false);
const lienVisible = ref(false);

async function copier() {
  try {
    await navigator.clipboard.writeText(sortie.lien);
    copie.value = true;
    track("inapp_browser", { ...sortie.params, result: "link_copied" });
  } catch {
    // Presse-papiers refusé (fréquent en webview) : le lien s'affiche, à sélectionner.
    lienVisible.value = true;
  }
}
</script>

<style lang="scss" scoped>
.aide-navigateur {
  // Au-dessus de tout (loader z 9, badge de version 9999) : Recette B1.
  z-index: 10000 !important;
  &__titre {
    margin-bottom: 0.75em;
  }
  &__alerte {
    font-weight: bold;
  }
  &__risque {
    font-size: 0.8em;
    opacity: 0.8;
    text-align: center;
    margin: 0.25em 0 0;
  }
  &__parent {
    font-size: 0.9em;
    opacity: 0.8;
  }
  &__lien {
    width: 100%;
    font-size: 0.85em;
    padding: 0.4em;
  }
  &__ici {
    display: block;
    margin: 0.75em auto 0;
    background: none;
    border: none;
    text-decoration: underline;
    color: inherit;
  }
}
</style>
